/**
 * Format a USD amount (string or number) to a display string.
 * E.g. 29.99 → "$29.99"
 */
export function formatPrice(amount: string | number): string {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(value)) return '$0.00';
  return `$${value.toFixed(2)}`;
}

/** @deprecated Use formatPrice instead */
export const formatCZK = formatPrice;
